import { useMemo } from 'react';

interface Props {
  isSvgObjectTypeIcon: boolean;
  heading: number | null;
  height: number;
  width: number;
}

/**
 * Fixme: This logic is expensive and should be replaced with a simpler implementation.
 * Using a RotatedMarker for an SVG is probably not the right approach.
 * Offsetting tooltips in such a specific way is also probably not the right approach.
 */
export const useObjectMarkerTooltipOffset = ({
  heading,
  width,
  height,
  isSvgObjectTypeIcon,
}: Props): [number, number] => {
  return useMemo<[number, number]>(() => {
    // Normalize heading to [0, 360]
    const safeHeading = heading ?? 0;
    const normalized = ((safeHeading % 360) + 360) % 360;
    const verticalNorth = -Math.round(isSvgObjectTypeIcon ? height / 2 : height / 1.8);
    const verticalSouth = -Math.round(isSvgObjectTypeIcon ? height / 2 : height / 3);
    const horizontal = -Math.round(width / (isSvgObjectTypeIcon ? 2 : 3));
    // North: 315-45 deg, South: 135-225 deg, East: 45-135 deg, West: 225-315 deg
    if (normalized >= 315 || normalized < 45) {
      return [0, verticalNorth];
    } else if (normalized >= 135 && normalized < 225) {
      return [0, verticalSouth];
    } else {
      // East or West: use width
      return [0, horizontal];
    }
  }, [height, width, heading, isSvgObjectTypeIcon]);
};
